import { isEssentialsV2Carrier } from "utils";

import { useRoleContext } from "./useRoleContext";
import { useShipmentFiltersContext } from "./useShipmentFiltersContext";
import { useSubscriptionStatus } from "./useSubscriptionStatus";

export function useShipmentsUrl() {
  const { role } = useRoleContext();
  const { filters } = useShipmentFiltersContext();
  const { subscription } = useSubscriptionStatus();

  const getUrl = (): string | null => {
    if (role == null) {
      return null;
    }
    if (role.type === "SHIPPER") {
      return `/shippers/${role.id}/shipments/condensed`;
    }
    if (role.type !== "CARRIER") {
      return null;
    }
    if (filters?.shipmentVisibility === "private") {
      return `/carriers/${role.id}/shipments/private/condensed`;
    }
    if (filters?.shipmentRelationship === "partner") {
      return `/carriers/${role.id}/shipments/partner`;
    }
    if (subscription == null || isEssentialsV2Carrier(subscription)) {
      // CARRIER_ESSENTIALS_V2 carriers are locked out of /shipments/condensed.
      // While subscription is still hydrating we also defer — issuing the
      // request optimistically would 403 V2 carriers on cold load.
      return null;
    }
    return "/shipments/condensed";
  };

  return { url: getUrl() };
}
